import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline';
import { CookiesProvider } from 'react-cookie';

import './index.css';

import { Store } from './store';
import App from './containers/NewApp';

ReactDOM.render(
  <div id="root-two">
    <Provider store={Store}>
      <CookiesProvider>
        <CssBaseline />
        <App />
      </CookiesProvider>
    </Provider>
  </div>,
  document.getElementById('root')
);
